import React, { useEffect, useContext } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableContainer from '@material-ui/core/TableContainer'
import TableHead from '@material-ui/core/TableHead'
import TableRow from '@material-ui/core/TableRow'
import Paper from '@material-ui/core/Paper'
import { NetworkStatus, useLazyQuery } from '@apollo/client'
import { GET_WEEK_VALUE } from '../queries/orders'
import TableSkeleton from './skeletons/TableSkeleton'
import { formatNumber } from '../utils/Helpers'
import { ProductFiltersContext } from '../context/ProductFiltersContext'
const useStyles = makeStyles({
  table: {
    minWidth: 650
  },
  padding: {
    paddingLeft: 15
  }
})

export default function BasicTable (): JSX.Element {
  const classes = useStyles()
  const { filters } = useContext(ProductFiltersContext)
  const [getData, { loading, error, data, networkStatus }] = useLazyQuery(
    GET_WEEK_VALUE, {
      notifyOnNetworkStatusChange: true
    }
  )

  useEffect(() => {
    getData({
      variables: { filters }
    })
  }, [filters])

  if (networkStatus === NetworkStatus.refetch) return <TableSkeleton />
  if (loading || !data) return <TableSkeleton />
  if (error) return <p>Error :(</p>
  if (!data.ordersAggs.aggregations) return <p>No data found</p>

  const { buckets } = data.ordersAggs.aggregations.data

  if (!data) return <></>
  return (
    <TableContainer component={Paper}>
      <Table className={classes.table} aria-label="simple table">
        <TableHead>
        <h3 className={classes.padding}>Mínima, média e máxima por dia da semana</h3>
          <TableRow>
            <TableCell>Dia</TableCell>
            <TableCell align="right">Mínima</TableCell>
            <TableCell align="right">Média</TableCell>
            <TableCell align="right">Máxima</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {buckets.map((bucket: any) => (
            <TableRow key={bucket.key}>
              <TableCell component="th" scope="row">
              {bucket.key === '1' ? 'Segunda-feira' : bucket.key === '2' ? 'Terça-Feira' : bucket.key === '3' ? 'Quarta-Feira' : bucket.key === '4' ? 'Quinta-Feira' : bucket.key === '5' ? 'Sexta-Feira' : bucket.key === '6' ? 'Sábado' : bucket.key === '7' ? 'Domingo' : null}
              </TableCell>
              <TableCell align="right">{formatNumber(bucket.minima.value, 2, true)}</TableCell>
              <TableCell align="right">{formatNumber(bucket.media.value, 2, true)}</TableCell>
              <TableCell align="right">{formatNumber(bucket.maxima.value, 2, true)}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  )
}
